import { render, staticRenderFns } from "./ShareDialog.vue?vue&type=template&id=577ba764&scoped=true&"
import script from "./ShareDialog.vue?vue&type=script&lang=js&"
export * from "./ShareDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShareDialog.vue?vue&type=style&index=0&id=577ba764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577ba764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('577ba764')) {
      api.createRecord('577ba764', component.options)
    } else {
      api.reload('577ba764', component.options)
    }
    module.hot.accept("./ShareDialog.vue?vue&type=template&id=577ba764&scoped=true&", function () {
      api.rerender('577ba764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/stream/ShareDialog.vue"
export default component.exports